/*!
 * @pixi/filter-displacement - v7.0.0-alpha
 * Compiled Fri, 09 Sep 2022 16:09:18 UTC
 *
 * @pixi/filter-displacement is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */import{Filter as m,Matrix as s,Point as u}from"@pixi/core";var p=`varying vec2 vFilterCoord;
varying vec2 vTextureCoord;

uniform vec2 scale;
uniform mat2 rotation;
uniform sampler2D uSampler;
uniform sampler2D mapSampler;

uniform highp vec4 inputSize;
uniform vec4 inputClamp;

void main(void)
{
  vec4 map =  texture2D(mapSampler, vFilterCoord);

  map -= 0.5;
  map.xy = scale * inputSize.zw * (rotation * map.xy);

  gl_FragColor = texture2D(uSampler, clamp(vec2(vTextureCoord.x + map.x, vTextureCoord.y + map.y), inputClamp.xy, inputClamp.zw));
}
`,l=`attribute vec2 aVertexPosition;

uniform mat3 projectionMatrix;
uniform mat3 filterMatrix;

varying vec2 vTextureCoord;
varying vec2 vFilterCoord;

uniform vec4 inputSize;
uniform vec4 outputFrame;

vec4 filterVertexPosition( void )
{
    vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;

    return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);
}

vec2 filterTextureCoord( void )
{
    return aVertexPosition * (outputFrame.zw * inputSize.zw);
}

void main(void)
{
	gl_Position = filterVertexPosition();
	vTextureCoord = filterTextureCoord();
	vFilterCoord = ( filterMatrix * vec3( vTextureCoord, 1.0)  ).xy;
}
`;class c extends m{constructor(r,e){const i=new s;r.renderable=!1,super(l,p,{mapSampler:r._texture,filterMatrix:i,scale:{x:1,y:1},rotation:new Float32Array([1,0,0,1])}),this.maskSprite=r,this.maskMatrix=i,e==null&&(e=20),this.scale=new u(e,e)}apply(r,e,i,a){this.uniforms.filterMatrix=r.calculateSpriteMatrix(this.maskMatrix,this.maskSprite),this.uniforms.scale.x=this.scale.x,this.uniforms.scale.y=this.scale.y;const t=this.maskSprite.worldTransform,n=Math.sqrt(t.a*t.a+t.b*t.b),o=Math.sqrt(t.c*t.c+t.d*t.d);n!==0&&o!==0&&(this.uniforms.rotation[0]=t.a/n,this.uniforms.rotation[1]=t.b/n,this.uniforms.rotation[2]=t.c/o,this.uniforms.rotation[3]=t.d/o),r.applyFilter(this,e,i,a)}get map(){return this.uniforms.mapSampler}set map(r){this.uniforms.mapSampler=r}}export{c as DisplacementFilter};
//# sourceMappingURL=filter-displacement.min.mjs.map
